/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import { useForm, Controller, ErrorMessage } from 'react-hook-form'
import { InputAdornment } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import Spinner from 'react-bootstrap/Spinner'
import { useSelector } from 'react-redux'
import TextField from '@material-ui/core/TextField'
import ProductsModal from '~/components/Sponsor/Modals/ProductsModal'
import useSponsorFunctions from '~/helper/sponsorFunctions'
import { StartDateSection, EndDateSection } from '~/components/Shared/CreateFormatDateSection'
import { InputTitle } from '~/components/Shared/StyledComponents'
import CreateFormatMobileVisualization from '~/components/CreateFormatMobileVisualization'
import ContentVisualization from '~/components/CreateFormatMobileVisualization/Content'
import { transformDateToUtcFormat } from '~/helper/getFormattedDates'
import DisplayCriteriaSelect from '~/components/DisplayCriteriaSelect'

import * as S from './styled'

export default function ModalPreviewVideo({
  handleCloseModal,
  showModal,
  videoToUpdate,
  review,
  createMessage,
  refuseCampaignProduct,
  approveCampaignProduct,
  sponsor,
}) {
  const { t } = useTranslation()
  const currentCampaignForReviewPage = useSelector(state => state.createCampaign.currentCampaignForReviewPage)
  const [loadingDebounce, setLoadingDebounce] = useState(false)
  const [scrapperDescription, setScrapperDescription] = useState(videoToUpdate.scrapperDescription)
  const [scrapperTitle, setScrapperTitle] = useState(videoToUpdate.scrapperTitle)
  const [scrapperImage, setScrapperImage] = useState(null)
  const [scrapperTags, setScrapperTags] = useState(null)
  const [scrapperLink, setScrapperLink] = useState(null)
  const [isUpdate, setIsUpdate] = useState(false)
  const [loadingImage, setLoadingImage] = useState(false)
  const { image, video, title } = videoToUpdate
  const [boost, setBoost] = useState(videoToUpdate.boost === true ? 'true' : 'false')
  const [imageId, setImageId] = useState(image)
  const [imageUrl, setImageUrl] = useState(videoToUpdate.imageUrl)
  const [date, setDate] = useState(transformDateToUtcFormat(videoToUpdate.date))
  const [endDate, setEndDate] = useState(transformDateToUtcFormat(videoToUpdate.endDate))
  const { handleSubmit, setValue, register, control, errors } = useForm()
  const { editProductAction } = useSponsorFunctions()

  function onSubmit(product) {
    const copyObject = JSON.stringify(videoToUpdate)
    const productCopy = JSON.stringify(product)

    if (copyObject === productCopy) {
      return
    }
    editProductAction('content/video', product)
    handleCloseModal()
  }

  function modalReviewCreateMessageAndCloseModal() {
    createMessage()
    refuseCampaignProduct()
    handleCloseModal()
  }

  useEffect(() => {
    register({ name: 'id' })
    register({ name: 'image' })
    register({ name: 'imageUrl' })
    setValue('image', imageId)
    setValue('imageUrl', imageUrl)
    setValue('id', videoToUpdate.id)
  }, [register, videoToUpdate.id, setValue, imageId, imageUrl])

  useEffect(() => {
    register({ name: 'scrapperTitle' })
    register({ name: 'scrapperDescription' })
    setValue('scrapperTitle', videoToUpdate.scrapperTitle)
    setValue('scrapperDescription', videoToUpdate.scrapperDescription)
  }, [scrapperTitle, scrapperDescription])

  return (
    <ProductsModal
      review={review}
      createMessage={modalReviewCreateMessageAndCloseModal}
      approveCampaignProduct={approveCampaignProduct}
      action={onSubmit}
      buttonText={review ? t('done') : t('update')}
      modalTitle={review ? t('reviseFormat', { format: t('video') }) : t('editFormat', { format: t('video') })}
      handleCloseModal={handleCloseModal}
      showModal={showModal}
      sponsor={sponsor}
      leftColumn={
        <form id="my-form" onSubmit={handleSubmit(onSubmit)}>
          <S.FormContainer>
            <InputTitle>{t('pastTheVideoLink')}</InputTitle>
            <Controller
              as={
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="https://www.example.com"
                  disabled={review || false}
                  InputProps={{
                    endAdornment: review ? null : (
                      <InputAdornment position="end">
                        {loadingDebounce ? <Spinner animation="border" size="sm" /> : ''}
                      </InputAdornment>
                    ),
                  }}
                />
              }
              rules={{ required: 'Video is required' }}
              name="video"
              control={control}
              defaultValue={video === null ? '' : video}
            />
            <div className="error-message">
              <ErrorMessage errors={errors} name="video" as="p" />
            </div>

            <div className="mt-3">
              <InputTitle>{t('title')}</InputTitle>
              <Controller
                as={<TextField fullWidth variant="outlined" placeholder={t('typeTitle')} disabled={review || false} />}
                rules={{ required: t('defaultValidation', { inputName: t('title') }) }}
                name="title"
                control={control}
                defaultValue={title === null ? '' : title}
              />
              <div className="error-message">
                <ErrorMessage errors={errors} name="title" as="p" />
              </div>
            </div>

            <div className="mt-3">
              <InputTitle>{t('description')}</InputTitle>

              <Controller
                as={
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder={t('typeDescription')}
                    disabled={review || false}
                  />
                }
                rules={{ required: t('defaultValidation', { inputName: t('description') }) }}
                name="scrapperDescription"
                control={control}
                defaultValue={scrapperDescription}
              />
              <div className="error-message">
                <ErrorMessage errors={errors} name="scrapperDescription" as="p" />
              </div>
            </div>

            <DisplayCriteriaSelect control={control} value={videoToUpdate?.privacy} disabled={review || false} />

            <StartDateSection
              product={t('video')}
              selectedCampaignStartDate={date}
              setCampaignStartDate={setDate}
              campaignStartDate={currentCampaignForReviewPage.dtStart}
              campaignEndDate={currentCampaignForReviewPage.dtEnd}
              disabled={review}
              control={control}
              errors={errors}
            />

            <EndDateSection
              product={t('video')}
              selectedCampaignStartDate={date}
              selectedCampaignEndDate={endDate}
              campaignEndDate={currentCampaignForReviewPage.dtEnd}
              setCampaignEndDate={setEndDate}
              disabled={review}
              control={control}
              errors={errors}
            />
          </S.FormContainer>
        </form>
      }
      rightColumn={
        <CreateFormatMobileVisualization
          FormatVisualizationComponent={
            <ContentVisualization
              loadingImage={loadingImage}
              image={imageUrl}
              title={scrapperTitle}
              about={scrapperDescription}
              contentType={t('video')}
            />
          }
        />
      }
    />
  )
}
